export const CartMessage = {
  deliveryCost:
    'Delivery costs will be determined and confirmed during order processing. Free delivery for orders over $500 GST excl.',
  deliveryCostExcluded: 'Delivery cost excluded',
  chargedToAccount: 'This order will be charged to your account once it has been fulfilled.',
  deliceryCostAdjustableTitle: 'Changes to delivery cost',
  deliveryCostAdjustable:
    'Adjustments to the products or quantity ordered may change the final delivery fee, any changes will be confirmed during processing.',
}
